import React from "react";
import { MainDiv } from "../../components/Profile/Profile.style";
import { VolunteerHeading } from "../../components/Volunteer/Volunteer.style";
import useProfile from "../../hooks/useProfile";
import TrialTablePage from "./TrialTablePage";
import { SearchAddDiv } from "../../components/style/Table.style";
import { ThemButton } from "../../components/Login/Login.style";
import { useNavigate, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import useGetAllStudies from "../../hooks/useGetAllStudies";

const CurrentTrialVolunteers = () => {
  const { trialCode } = useParams();
  const navigate = useNavigate();
  const [userData, isLoading] = useProfile();
  if (isLoading) {
    return "";
  }
  const user = userData.ugleve_name;
  const moveDashboard = () => {
    navigate("/");
  };

  //! fetching study list
  // const { data: studyInfo = [] } = useQuery({
  //   queryKey: ["studyInfo"],
  //   queryFn: async () => {
  //     const res = await fetch(
  //       `${process.env.REACT_APP_API_URL}/api/studyDropdown`
  //     );
  //     const data = await res.json();
  //     // console.log("study list in histiry=-> ", data);
  //     return data;
  //   },
  // });
  

  return (
    <MainDiv>
      <SearchAddDiv>
        <VolunteerHeading>Current Trial Volunteers</VolunteerHeading>
        <div>
          <ThemButton onClick={() => moveDashboard()}>
            Back to dashboard
          </ThemButton>
        </div>
      </SearchAddDiv>
      <TrialTablePage user={user} trialCode={trialCode}></TrialTablePage>
    </MainDiv>
  );
};

export default CurrentTrialVolunteers;
